import React from 'react';
import { Item } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';

const RewardsCategoryList = (props) => {
    return (
        <Item.Group divided>
            {
                _.map(props.category, (category) => {
                    const {
                        slug,
                        name
                    } = category;
                    return (
                        <Item key={slug}>
                            { slug === "food-beverage-disc" && <Item.Image src={"https://s3-ap-southeast-1.amazonaws.com/mhc.static/Rewards/rewards_food.png"} />}
                            { slug === "health-fitness-disc" && <Item.Image src={"https://s3-ap-southeast-1.amazonaws.com/mhc.static/Rewards/rewards_health.png"} />}
                            { slug === "shopping-retail" && <Item.Image src={"https://s3-ap-southeast-1.amazonaws.com/mhc.static/Rewards/rewards_essentials.png"} />}
                            { slug === "lifestyle-recreation" && <Item.Image src={"https://s3-ap-southeast-1.amazonaws.com/mhc.static/Rewards/rewards_lifestyle.png"} />}
                            <Item.Content>
                                <Item.Header>
                                    <Link to={`/app/rewards/${slug}/${name}`}>
                                        {name}
                                    </Link>
                                </Item.Header>
                            </Item.Content>
                        </Item>
                    );
                })
            }
        </Item.Group>
    );
}

export default RewardsCategoryList;
